namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem9Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem9';
    }
}
